import { useState, useEffect } from "react";

export default (props) => {
    const [time, setTime] = useState('');
    const [date, setDate] = useState('');
    useEffect(() => {
        const updateClock = () => {
          const now = new Date().toLocaleString("en-US", { timeZone: "Europe/Istanbul" });
          const formattedTime = new Intl.DateTimeFormat("tr-TR", {
            timeStyle: "medium"
          }).format(new Date(now));

          const formattedDate = new Date().toLocaleDateString("tr-TR", {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
          });

          setTime(formattedTime);
          setDate(formattedDate);
        };

        // Update the clock every second
        const intervalId = setInterval(updateClock, 1000);

        // Initialize clock
        updateClock();

        // Clear interval on component unmount
        return () => clearInterval(intervalId);
    }, []);

    return (
        <div style={{display: 'flex', alignItems: 'center'}}>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
                marginRight: '8px'
            }}>
                <div style={{
                    fontFamily: 'monospace',
                    fontSize: '16px',
                    color: '#5a9bd4',
                    textShadow: '0 0 10px rgba(20, 52, 92, 0.5)',
                    fontWeight: '700'
                }}>
                    {time}
                </div>
                <div style={{
                    fontSize: '11px',
                    color: '#5a9bd4',
                    textShadow: '0 0 8px rgba(20, 52, 92, 0.4)',
                    fontWeight: '500',
                    marginTop: '2px'
                }}>
                    {date}
                </div>
            </div>
            <img src={`${process.env.PUBLIC_URL}/tr-flag.webp`} style={{width: 20, paddingTop: 1, filter: 'drop-shadow(0 0 3px rgba(20, 52, 92, 0.3))'}} />
        </div>
    )
}